import React from 'react';
import { Card, NonIdealState, Intent, Button } from "@blueprintjs/core";
import FadeIn from 'react-fade-in'

class CreatePanelSequencesTable_Sequences extends React.Component {
    handleDeleteSequence = (id) => {
        const { onDeleteSequence } = this.props;

        onDeleteSequence(id);
    }

    render() {
        const { sequences = [], resources = [], deleting, onGenerateSequences, onShuffleSequences, instances = [] } = this.props;

        if (sequences.length <= 0)
            return (
                <FadeIn>
                    <NonIdealState
                        icon="th-list"
                        className="margin-top-medium"
                        title="Generate sequences"
                        description="When you are done downloading images, you can generate sequences automatically !"
                        action={
                            <Button
                                text="Generate sequences"
                                rightIcon="updated"
                                intent={Intent.PRIMARY}
                                onClick={onGenerateSequences} />} />
                </FadeIn>
            );
        return (
            <FadeIn>
                <div>
                    <div className="text-right">
                        <Button
                            intent={Intent.PRIMARY}
                            rightIcon="updated"
                            text="Generate Again"
                            style={{ marginBottom: '20px', marginTop: '20px', marginRight: '5px' }}
                            onClick={() => onGenerateSequences(true)}
                            disabled={instances.length !== 0} />
                        <Button
                            intent={Intent.PRIMARY}
                            rightIcon="random"
                            text="Mix sequences"
                            style={{ marginBottom: '20px', marginTop: '20px' }}
                            onClick={() => onShuffleSequences(true)}
                            disabled={instances.length !== 0} />
                    </div>
                    <Card>
                        <table className="bp3-html-table full-width">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Ressources</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {sequences.map((s, index) =>
                                    <tr key={index}>
                                        <td>Sequence {(index + 1)}</td>
                                        <td>{s.resources.map((r, index) => (<span key={index}>
                                            {resources.map((originalR, secondI) => {
                                                if (r.id === originalR.id) {
                                                    if (index === 0) {
                                                        return <span key={index + secondI}>{originalR.name}</span>
                                                    } else {
                                                        return <span key={index + secondI}>{`, ${originalR.name}`}</span>
                                                    }
                                                }
                                                return null
                                            })}
                                        </span>))}</td>
                                        <td style={{ textAlign: "right" }}>
                                            <Button
                                                icon="trash"
                                                loading={deleting}
                                                minimal={true}
                                                onClick={() => this.handleDeleteSequence(s.id)}
                                                disabled={instances.length !== 0} />
                                        </td>
                                    </tr>)}
                            </tbody>
                        </table>
                    </Card>
                </div>
            </FadeIn>
        );
    }
}

export default CreatePanelSequencesTable_Sequences;